import {Routes} from '@angular/router';
import {MsalGuard, MsalRedirectComponent} from '@azure/msal-angular';
import {roleGuard} from "@core/guards/role.guard";
import {ApplicationRole} from "@core/enumerations/application-role.enum";

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full'
  },
  {
    path: 'auth',
    component: MsalRedirectComponent
  },
  {
    path: 'home',
    loadComponent: () => import('./modules/home/home.component').then(x => x.HomeComponent),
    canActivate: [MsalGuard]
  },
  {
    path: 'dashboard/:id',
    loadComponent: () => import('./modules/dashboard/dashboard.component').then(x => x.DashboardComponent),
    canActivate: [MsalGuard],
  },
  {
    path: 'reports',
    loadComponent: () => import('./modules/report/report.component').then(x => x.ReportComponent),
    canActivate: [MsalGuard, roleGuard], data: {roles: ApplicationRole.administrator}
  },
  {
    path: 'users',
    loadComponent: () => import('./modules/user/user.component').then(x => x.UserComponent),
    canActivate: [MsalGuard, roleGuard], data: {roles: ApplicationRole.administrator}
  },
  {
    path: 'roles',
    loadComponent: () => import('./modules/role/role.component').then(x => x.RoleComponent),
    canActivate: [MsalGuard, roleGuard], data: {roles: ApplicationRole.administrator}
  },
  {
    path: 'welcome-messages',
    loadComponent: () => import('./modules/welcome-messages/welcome-messages.component').then(m => m.WelcomeMessagesComponent),
    canActivate: [MsalGuard, roleGuard], data: {roles: ApplicationRole.administrator}
  },
  {
    path: 'login-failed',
    loadComponent: () => import('./modules/login-failed/login-failed.component').then(x => x.LoginFailedComponent),
  },
  {
    path: 'unauthorized',
    loadComponent: () => import('./modules/unauthorized/unauthorized.component').then(x => x.UnauthorizedComponent),
  },
  {
    path: '**',
    redirectTo: 'home',
    pathMatch: 'full'
  }
];


